import type { ExportImageOptions } from "@/core/export-image"

type PublishExportSettings = Pick<
	ExportImageOptions,
	"quality" | "colorSpace" | "ppi" | "resizeWidth" | "resizeHeight" | "resizeMode"
>

export const getPublishExportSettingsKey = (options: PublishExportSettings) =>
	JSON.stringify([
		1,
		options.quality ?? null,
		options.colorSpace ?? null,
		options.ppi ?? null,
		options.resizeWidth ?? null,
		options.resizeHeight ?? null,
		options.resizeMode ?? null,
	])
